/**
 * Returns a numeric regex pattern to match number values with given characters length
 * @param {number[]} lengths
 * @returns {RegExp} numeric regex pattern
 * @example
 * getNumericPattern([3, 8])
 * returns /^(\d{3}|\d{8})$/
 * @category Utils
 */
const getNumericPattern = (lengths: number[]) => {
  const regexp = Array.from(new Set(lengths), (len) => `\\d{${len}}`).join('|')
  return new RegExp(`^(${regexp})$`)
}

/**
 * Generates a regular expression pattern matching alphanumeric strings of specified lengths.
 * @param lengths An array of numbers representing the lengths of alphanumeric strings.
 * @returns A regular expression pattern.
 * @category Utils
 */
const getAlphanumericPattern = (lengths: number[]) => {
  const regexp = Array.from(new Set(lengths), (len) => `\\w{${len}}`).join('|')
  return new RegExp(`^(${regexp})$`)
}

/**
 * Get the gift card number and pin validation patterns
 * @param data
 * @param data.cardNumberLengths Card Number Lengths
 * @param data.cardPinLengths Card Pin Lengths
 * @returns {any} { cardNumber: RegExp; cardPin: RegExp; } The RegExp of cardNumber and cardPin
 * @category Utils
 */
export const getGiftCardFormValidationPatterns = (data: {
  cardNumberLengths: number[]
  cardPinLengths: number[]
}) => ({
  cardNumber: getNumericPattern(data.cardNumberLengths),
  alphanumericCardNumber: getAlphanumericPattern(data.cardNumberLengths),
  cardPin: getNumericPattern(data.cardPinLengths)
})
